import React, { Component } from "react";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import {
    createStyles,
    Text,
    Avatar,
    Group,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
    Image
} from '@mantine/core';

import {
    IconFlag,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp
} from '@tabler/icons';

import pagani from '../assets/pagani.jpg';

const useStyles = createStyles((theme) => ({
    comment: {
        padding: `${theme.spacing.lg}px ${theme.spacing.xl}px`,
    },

    body: {
        paddingLeft: 54,
        paddingTop: theme.spacing.sm,
        fontSize: theme.fontSizes.sm,
    },

    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
    canvasStyle: {
        width: '50%',
        height: '50%',
        background: '#111'
    }
}));


//needed: set this.props.image as the image we need to render
//needed: calculate image center for width and height props
//needed: add arrows to move from pic to pic
//needed: make this a function component
export class CanvasCardBase extends Component {
    render() {
        return (
            <TransformWrapper
                initialScale={0.5}
                minScale={0.5}
                limitToBounds={false}
                centerOnInit={false}
                doubleClick={{mode: "reset"}}
                
            >
                <TransformComponent>
                    <img src={pagani} alt="test" />
                </TransformComponent>
            </TransformWrapper>
    );
  }
}

